import type { User } from "@web-app/types";
import http from "@web-app/utils/http";

export const getSessionUser = async () => {
  return http.post<User>("/auth/sessionUser").then((response) => response.data);
};
